import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SEO from "../components/SEO";
import { Chapter, MaskedLine } from "../components/Reveal";
import { SERVICES, LOCATIONS } from "../data/content";
import { MARKETS } from "../data/markets";
import { INDUSTRIES } from "../data/industries";

const Group = ({ index, label, links }) => (
  <section className="mx-auto max-w-7xl px-4 pb-16 sm:px-8 lg:px-16">
    <Chapter index={index} label={label} />
    <ul className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
      {links.map((l) => (
        <li key={l.to}>
          <Link
            to={l.to}
            className="flex min-h-[56px] items-center justify-between gap-3 rounded-2xl border border-white/10 bg-ink px-5 py-4 text-sm text-white/80 transition-colors hover:border-ember/40 hover:text-white"
          >
            <span>
              <span className="block font-display font-bold">{l.title}</span>
              {l.desc && <span className="mt-1 block text-xs text-white/45">{l.desc}</span>}
            </span>
            <ArrowUpRight className="h-4 w-4 shrink-0 text-ember" />
          </Link>
        </li>
      ))}
    </ul>
  </section>
);

/** Hub page linking every service, market, city and industry page. */
export default function Services() {
  return (
    <main className="pt-36 lg:pt-44" data-testid="services-page">
      <SEO path="/services" breadcrumbs={[{ name: "Home", path: "/" }, { name: "Services", path: "/services" }]} />
      <section className="mx-auto max-w-7xl px-4 pb-16 sm:px-8 lg:px-16">
        <Chapter index="—" label="Services" />
        <h1 className="mt-8 max-w-4xl font-display text-4xl font-black leading-[1.04] tracking-tight sm:text-5xl lg:text-6xl">
          <MaskedLine>Website Development, SEO, Shopify & AI Services</MaskedLine>
        </h1>
        <p className="mt-6 max-w-3xl text-base leading-relaxed text-white/60 sm:text-lg">
          Everything Grotech Web builds for businesses in India, the USA and the UAE: lead-generating websites, SEO, Shopify stores, AI chatbots and automation. Pick a service, or find the page for your country, city or industry. Prices start from ₹25,000, $999 or AED 3,499; see <Link to="/pricing/" className="text-ember underline-offset-2 hover:underline">pricing</Link>.
        </p>
      </section>
      <Group index="01" label="Services" links={SERVICES.map((s) => ({ to: `/${s.slug}/`, title: s.heroTitle, desc: s.short }))} />
      <Group index="02" label="By country" links={MARKETS.map((m) => ({ to: `/${m.slug}/`, title: m.heroTitle }))} />
      <Group index="03" label="Cities in India" links={LOCATIONS.filter((l) => l.label).map((l) => ({ to: `/${l.slug}/`, title: l.heroTitle || l.label }))} />
      <Group index="04" label="By industry" links={INDUSTRIES.map((i) => ({ to: `/website-development-for-${i.slug}/`, title: i.heroTitle }))} />
    </main>
  );
}
